import { useEffect, useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { Button } from "../../components";
import { ButtonType } from "../../components/button";
import { fileUrl } from "../../redux/base/url";
import { getSliderList } from "../../redux/definitions";
import { Slider } from "../../redux/definitions/types/Slider";
const Ad = () => {
  const dispatch = useDispatch();
  const [sliderData, setSliderData] = useState<Slider>();
  const history = useHistory();
  useEffect(() => {
    dispatch(
      getSliderList({
        payload: {
          onSuccess: (message, payload) => {
            payload && payload.length > 0 && setSliderData(payload[0]);
          },
          onError: (message) => {},
        },
        url: "api/definitions/slider",
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container mt-5">
      {sliderData && (
        <Row>
          <Col md={6}>
            <div className="w-100 h-100 d-flex flex-column justify-content-center ">
              <p
                className="header-title"
                dangerouslySetInnerHTML={{
                  __html: sliderData.Title,
                }}
              />
              <p
                className="header-subtitle"
                dangerouslySetInnerHTML={{
                  __html: sliderData.SubTitle,
                }}
              />
              {sliderData.LinktoCar && sliderData.CarID && (
                <Button
                  buttonType={ButtonType.newColored}
                  title={"DETAYLI İNCELE"}
                  icon={<BsArrowRight />}
                  iconPosition="right"
                  onClick={() => {
                    history.push(`/car-details/` + sliderData.CarID);
                  }}
                />
              )}
            </div>
          </Col>

          <Col md={6}>
            <img
              src={fileUrl(sliderData.Image)}
              alt=""
              width={"100%"}
              height={"auto"}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};
export default Ad;
